import { Component, OnInit, OnChanges, SimpleChanges, Input, Output } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { EventEmitter } from '@angular/common/src/facade/async';
import { OnDemandDriversService } from '../../on-demand-drivers.service';

@Component({
  selector: 'app-on-demand-drivers-change-logs',
  templateUrl: './change-logs.component.html',
  styleUrls: ['./change-logs.component.scss']
})
export class ChangeLogsComponent implements OnInit, OnChanges {

  private logGrid: GridOptions;

  @Input() selected: number;
  @Output() notify: EventEmitter < boolean > = new EventEmitter < boolean > ();
  @Output() cancel: EventEmitter < boolean > = new EventEmitter < boolean > ();

  constructor(protected service: OnDemandDriversService) {
    this.logGrid = < GridOptions > {};
    this.configureGrid();
  }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges): void {
    const selectedChange = changes['selected'];

    if (
      selectedChange &&
      !selectedChange.isFirstChange() &&
      selectedChange.currentValue &&
      selectedChange.currentValue !== selectedChange.previousValue
    ) {
      if (this.logGrid && this.logGrid.api) {
        this.logGrid.api.setRowData([]);
      }
      this.getLog();
    }
  }

  /**
   * @name cancelCreateEdit
   * @description
   */
  public cancelCreateEdit() {
    this.cancel.emit(true);
  }

  /**
   * @name getLog
   * @description
   */
  private getLog() {
    this.service
      .getDriverHistoy(this.selected)
      .subscribe(
        data => {
          if (this.logGrid) {
            if (this.logGrid.api) {
              this.logGrid.api.setRowData(data);
            }
          }
        }
      );
  }

  /**
   * @name configureGrid
   * @description
   */
  private configureGrid() {
    const self = this;
    this.logGrid.columnDefs = [{
        headerName: 'Date',
        field: 'date',
        colId: 'date'
      }, {
        headerName: 'Time',
        field: 'time',
        colId: 'time'
      }, {
        headerName: 'Description',
        field: 'description',
        colId: 'description'
      }, {
        headerName: 'User',
        field: 'userprofiledata.fullname',
        colId: 'userprofile'
      }
    ];

    this.logGrid.enableFilter = true;

    this.logGrid.onGridReady = function () {
      self.logGrid.api.sizeColumnsToFit();
      self.getLog();
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/on-demand-drivers/components/change-logs/change-logs.component.ts